<template>
    <div class="tree-container">
        <MermaidRenderer 
            :diagram="generateDiagram()"
            @nodeDblClick="handleNodeClick"
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import MermaidRenderer from '../MermaidRenderer.vue';

const props = defineProps({
    categories: {
        type: Array,
        required: true
    }
});

const router = useRouter();

const generateDiagram = () => {
    let diagram = 'flowchart TD\n';
    
    // Определяем стили для нод
    diagram += 'classDef default fill:#fff,stroke:#eee,stroke-width:1px\n';
    diagram += 'classDef active fill:#fff,stroke:#3fe7de,stroke-width:2px\n';
    diagram += 'classDef root fill:#fff,stroke:#3fe7de,stroke-width:2px\n';
    
    // Добавляем ноды
    props.categories.forEach(category => {
        const hasImages = category.images_count > 0;
        const thumbUrl = category.thumbnail_url ? `https://api.labhub.online${category.thumbnail_url}` : null;
        
        // Создаем HTML-содержимое ноды с кликабельным счетчиком
        const nodeContent = `<a href='/atlas/${category._id}'><div class='node-content'>
            ${thumbUrl ? `<div class='node-image-wrapper'><img src='${thumbUrl}' class='node-image'/></div>` : ''}
            <div class='node-title'>${category.name}</div>
            ${hasImages ? `<div class='node-counter'>
                
                <div class='counter-link'>
                    ${category.images_count} фото
                </div>
               
            </div>` : ''}
        </div> </a>`;
        
        diagram += `    ${category._id}["${nodeContent.replace(/"/g, '\\"').replace(/\n/g, ' ')}"]\n`;
        
        // Применяем стиль
        if (!category.parent_id) {
            diagram += `    class ${category._id} ${hasImages ? 'active' : 'root'}\n`;
        } else {
            diagram += `    class ${category._id} ${hasImages ? 'active' : 'default'}\n`;
            diagram += `    ${category.parent_id} --> ${category._id}\n`;
        }
    });
    
    return diagram;
};

const handleNodeClick = (nodeId) => {
    const cleanId = nodeId.replace('mermaid-diagram-', '');
    const category = props.categories.find(cat => cat._id === cleanId);
    
    if (category?.images_count > 0) {
        router.push({
            name: 'AtlasCategoryView',
            params: { id: cleanId }
        });
    }
};
</script>

<style scoped>
.tree-container {
    background: white;
    border-radius: 10px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: 100%;
    min-height: 400px;
    overflow: auto;
}

:deep(.node-content) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    width: 180px;
    gap: 4px;
}

:deep(.node-image-wrapper) {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

}

:deep(.node-image) {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

:deep(.node-title) {
    font-size: 14px;
    font-weight: 500;
    color: #193b68;
    text-align: center;
    margin: 0;
    width: 160px;
    word-wrap: break-word;
    white-space: normal !important;
}

:deep(.node-counter) {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
}

:deep(.counter-link) {
    display: inline-block;
    background: #e3f2fd;
    color: #1384c5;
    padding: 4px 12px;
    border-radius: 12px;
    transition: background-color 0.2s;
    cursor: pointer;
}

:deep(.counter-link:hover) {
    background: #b3e0fc;
    color: #0d5d8f;
}

:deep(.node rect) {
    rx: 8px;
    ry: 8px;
}

:deep(.node.active) {
    cursor: pointer;
}

:deep(.node.active:hover rect) {
    filter: brightness(0.98);
}

:deep(.edgeLabel) {
    background-color: white !important;
}

:deep(.edge-pattern-solid) {
    stroke-width: 1px;
}

@media (max-width: 768px) {
    .tree-container {
        padding: 10px;
    }
    
    :deep(.node-content) {
        width: 140px;
    }
    
    :deep(.node-title) {
        width: 120px;
        font-size: 12px;
    }
    
    :deep(.node-image-wrapper) {
        width: 50px;
        height: 50px;
    }
}
</style>